module.exports = __webpack_public_path__ + "static/media/black_joker.90a98f61.png";